// extracted by mini-css-extract-plugin
export default {"cls1":"RatingCard-cls1__fa11f718b1942aebbd8d","cls2":"RatingCard-cls2___36a87b6c4ff53c23f10 RatingCard-cls1__fa11f718b1942aebbd8d"};